<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>February 8</h1>
          <div class="text-left">
              <p>Stayed at Exeter</p>
          </div>      
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>